import React, { useState } from 'react'; // Removed unused useEffect
import {
    Form,
    Space,
    Card,
    Typography,
    Divider,
    Spin,
    Checkbox,
    Switch,
    Row,
    Col
} from 'antd';
import { AppstoreAddOutlined, ScissorOutlined } from '@ant-design/icons';
import { getIcon } from '../utils/iconMap';

const { Title, Text, Paragraph } = Typography;

const StructureComponents = ({
                                 form,
                                 formValues,
                                 setFormValues,
                                 suggestedTemplates = [],
                                 allTemplates = [],
                                 allComponents = [],
                                 isLoading = false
                             }) => {

    const [showAll, setShowAll] = useState(false);
    const templatesToRender = showAll ? allTemplates : suggestedTemplates;

    const showLoading = !showAll && isLoading;

    const showEmptyMessage =
        (showAll && allTemplates.length === 0) ||
        (!showAll && !isLoading && suggestedTemplates.length === 0);

    const showTemplateList = !showLoading && !showEmptyMessage;

    let emptyTitle = "No Templates Found";
    let emptyMessage = "Could not find any templates matching your criteria. Try showing all templates.";
    if (showAll && allTemplates.length === 0) {
        emptyTitle = "No Templates Available";
        emptyMessage = "The lesson template configuration could not be loaded.";
    }

    return (
        <Space orientation="vertical" style={{ width: '100%' }} size="large">
            <Title level={5}><AppstoreAddOutlined /> Lesson Structure</Title>
            <Form.Item label="Template Selection Mode" style={{ marginBottom: 0 }}>
                <Switch
                    checkedChildren="Showing all templates"
                    unCheckedChildren="Showing suggested only"
                    checked={showAll}
                    onChange={setShowAll}
                    disabled={isLoading} // Disable switch while suggestions are loading
                />
            </Form.Item>


            {showLoading && (
                <div style={{ textAlign: 'center', padding: '50px' }}>
                    <Spin description="Finding the best templates for your lesson..." size="large" />
                </div>
            )}

            {showEmptyMessage && (
                <div style={{ textAlign: 'center', padding: '50px' }}>
                    <Title level={5}>{emptyTitle}</Title>
                    <Paragraph type="secondary">
                        {emptyMessage}
                    </Paragraph>
                </div>
            )}

            {showTemplateList && (
                <>
                    <Paragraph type="secondary">
                        {showAll
                            ? "Browse all available lesson structures."
                            : "Based on your initial choices, here are the best lesson structures for your goals."
                        }
                    </Paragraph>
                    <Form.Item label="Select a Lesson Template" name="lessonPlanTemplateId" rules={[{ required: true, message: 'Please select a lesson plan template.' }]}>
                        <Space orientation="vertical" style={{ width: '100%' }} size="middle">
                            {templatesToRender.map(template => {
                                // Use 'value' from OptionDto, fallback to 'id' from search doc
                                const templateId = template.value || template.id;
                                // Use 'label' from OptionDto, fallback to 'displayName' from search doc
                                const templateLabel = template.label || template.displayName;

                                return (
                                    <Card
                                        key={templateId}
                                        size="small"
                                        hoverable
                                        style={{
                                            border: formValues.lessonPlanTemplateId === templateId ? '2px solid #1677ff' : '1px solid #d9d9d9',
                                            backgroundColor: formValues.lessonPlanTemplateId === templateId ? '#e6f4ff' : '#ffffff',
                                        }}
                                        onClick={() => {
                                            form.setFieldsValue({ lessonPlanTemplateId: templateId });
                                            setFormValues(prev => ({ ...prev, lessonPlanTemplateId: templateId }));
                                        }}
                                    >
                                        <Title level={5} style={{ margin: 0 }}>
                                            <Space>
                                                {getIcon(template.icon || 'AppstoreAddOutlined')}
                                                {templateLabel}
                                            </Space>
                                        </Title>
                                        <Text type="secondary">{template.description}</Text>
                                    </Card>
                                );
                            })}
                        </Space>
                    </Form.Item>
                </>
            )}

            <Divider />

            <Title level={5}><ScissorOutlined /> Lesson Components</Title>
            <Paragraph type="secondary">
                Uncheck any sections you don't need in the final lesson plan document.
            </Paragraph>
            <Form.Item
                name="lessonPlanComponents"
                rules={[{ required: true, message: 'Please select at least one component.' }]}
            >
                <Checkbox.Group style={{ width: '100%' }}>
                    <Row gutter={[16, 16]}> {/* Added gutter for spacing */}
                        {allComponents.map(component => (
                            <Col xs={24} sm={12} key={component.value}> {/* 2-column layout */}
                                <Checkbox value={component.value}>
                                    <Text>{component.label}</Text>
                                </Checkbox>
                            </Col>
                        ))}
                    </Row>
                </Checkbox.Group>
            </Form.Item>
        </Space>
    );
};

export default StructureComponents;